import { useState } from 'react'

import { usePermissions } from '@/hooks/usePermissions'
import { useSelector } from 'react-redux'

import { DrawerScrollContainer, PanelContainer } from '@/components/ui'
import { selectEditMode } from '@/redux/ui/uiSlice'

import { FloorI } from '../../types/types'
import { FloorList } from './FloorList'
import { FloorListToggle } from './FloorListToggle'
import { FloorsPanelHeader } from './FloorsPanelHeader'

export interface FloorsPanelIProps {
  floors: FloorI[]
  currentFloorId?: string
  onReorderFloors?: (floorIds: string[]) => void
}

export const FloorsPanel = ({
  floors,
  currentFloorId,
  onReorderFloors,
}: FloorsPanelIProps) => {
  const { shouldEnableUpdateFloor } = usePermissions()
  const isEditMode = useSelector(selectEditMode)
  const [shouldFilterFloorsWithIncidents, setFilterFloorsWithIncidents] =
    useState(false)

  const onFilterToggle = () => {
    setFilterFloorsWithIncidents(!shouldFilterFloorsWithIncidents)
  }

  const filteredFloors = shouldFilterFloorsWithIncidents
    ? floors?.filter((i) => i.hasIncidents)
    : floors

  const canReorderFloors =
    shouldEnableUpdateFloor && isEditMode && !shouldFilterFloorsWithIncidents

  return (
    <PanelContainer w='390px'>
      <FloorsPanelHeader />
      <DrawerScrollContainer px='30px' py='20px'>
        <FloorListToggle
          checked={shouldFilterFloorsWithIncidents}
          onToggle={onFilterToggle}
        />
        <FloorList
          canReorderFloors={canReorderFloors}
          currentFloorId={currentFloorId}
          floors={filteredFloors}
          onReorderFloors={onReorderFloors}
        />
      </DrawerScrollContainer>
    </PanelContainer>
  )
}
